module.exports = "https://static.wagwalking.com/_next/static/images/Avatar-008a682a72f4a194d8074f275515ed4e.svg";